import React from "react";
import { useTranslation } from "../../hooks/useTranslation";
import { MEDIA_URL } from '../../config/constants';

const CTABanner = () => {
  const { t } = useTranslation('home');
  const discounts = t('cta.discounts', { returnObjects: true });

  return (
    <div className="cta-banner">
      <div className="cta-background-container">
        <img
          src={`${MEDIA_URL}/images/adventure-awaits-banner-surf-sports.webp`}
          className="cta-background"
          alt="Surfer with board next to campervan on Portuguese beach at sunset"
          loading="lazy"
          width="1200"
          height="588"
        />
        <div className="cta-content-wrapper">
          <div className="cta-content-container">
            <div className="cta-text-content">
              <div className="cta-offer-container">
                <div className="offer-icon">{t('cta.offerIcon')}</div>
                <div className="offer-text">{t('cta.offerText')}</div>
              </div>
              <h2 className="cta-main-heading">
                {t('cta.title')}
              </h2>
              <div className="cta-subheading">
                {t('cta.description')}
              </div>
              <ul className="cta-discounts-list">
                {discounts.map((discount, index) => (
                  <li key={index}>{discount}</li>
                ))}
              </ul>
              <div className="cta-promo-text">
                {t('cta.promoText')}
              </div>
            </div>
            <div className="cta-availability-container">
              <div className="cta-button-container">
                <div className="cta-button">
                  <div className="button-state-layer">{t('cta.button')}</div>
                </div>
              </div>
              <div className="availability-text">{t('cta.availability')}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTABanner;
